module.exports = __webpack_public_path__ + "img/evil_spirit.a04adb0b.webp";